import { EFT_INSTRUCTIONS_IGF, WIRING_INSTRUCTIONS_IGF } from 'src/app/_core/contants/wiring-instructions';
import { EnvironmentNames } from 'src/app/_core/contants/environments';

// IGF on the FMS test environment (https://fms-test-igf.trustbridgeglobal.com).
//
// One shared portal backend serves this tier: the fms-test service (`test-sso` Spring profile), which
// GLF's host also fronts. The backend is multi-tenant and separates IGF from GLF by the `tenantId`
// header this file sets (TenantContextListener), so `server` is GLF's host, not this one — only `url`
// differs between the two tenants. A per-tenant fms-test-igf backend was provisioned but dropped in
// favour of a single deployment.
//
// Branding is taken from environment.igf-test.ts, but its auth block is deliberately NOT copied —
// that file is marked NOT ACTIVE and still points at the dev realm with igf_dev clients. Auth here
// follows the GLF test-bt shape: the BenevaTechTest realm with igf_test clients.
export const environment = {
  // Assets
  primaryColor: 'rgb(14, 80, 160)',
  secondaryColor: 'rgb(217, 245, 255)',
  ternaryColor: 'rgb(14, 80, 160)',
  logo: 'assets/logos/igf.png',
  publicLogo: 'assets/logos/igf.jpg',
  lightDonateNowButtonLink:
    'https://tbportal-prod-assets.s3.us-east-1.amazonaws.com/igf/IGF%20Donate%20Button%20%28Light%29.png',
  darkDonateNowButtonLink:
    'https://tbportal-prod-assets.s3.us-east-1.amazonaws.com/igf/IGF%20Donate%20Button%20%28Dark%29.png',
  lightDonateNowButtonSrc: 'assets/donate-buttons/igf_light_donate_button.png',
  darkDonateNowButtonSrc: 'assets/donate-buttons/igf_dark_donate_button.png',
  favicon: 'assets/favicon/igf.ico',
  wiringInstructions: WIRING_INSTRUCTIONS_IGF,
  eftInstructions: EFT_INSTRUCTIONS_IGF,
  stripeKey:
    'pk_test_51U5m6UH0d5tOwyDscXd9QC9b3obHWcSl8eBCpgjd8rpPubpBRVRTF5RfHhhW2z6Te1U3tvjwnNG58IxtFOLgeM0V002epJYpxp',
  homeLink: 'https://www.internationalgenerosity.com/',
  contact:
    'https://6239938.extforms.netsuite.com/app/site/crm/externalleadpage.nl?compid=6239938&formid=2&h=AAFdikaIdKlYEs4FAj_L3P74vXUHG8WCn2Ke3jOQPWsYKkn0qHs&custenity_refer_source=web-portal',
  blog: '',
  privacyPolicy: 'https://www.internationalgenerosity.com/privacy',
  terms: 'https://www.internationalgenerosity.com/terms',
  mailTo: 'admin@internationalgenerosity.com',
  name: 'International Generosity Foundation',
  // Server
  tenantId: 'igf_test',
  server: 'https://fms-test.trustbridgeglobal.com/api',
  url: 'https://fms-test-igf.trustbridgeglobal.com',
  gsUrl: 'https://test.givingspace.com',
  // Frontend Logic
  production: false,
  environmentName: EnvironmentNames.IGF,
  languages: ['en-igf'],
  multiCurrency: false,
  // App-switch target. igf-test pointed this at the SWISS portal (imported from swiss-test); the
  // equivalent on this tier is the SWISS FMS test host, which runs the givingspace frontend.
  redirectSourceUrl: 'https://fms-test-swiss.trustbridgeglobal.com',
  backendClientId: 'igf_test-portal-backend',
  authConfig: {
    issuer: 'https://test.sso.benevatech.com/auth/realms/BenevaTechTest',
    redirectUri: window.location.origin,
    clientId: 'igf_test-portal-public',
    responseType: 'code',
    scope: 'openid profile email links',
    showDebugInformation: true,
    sessionChecksEnabled: true,
  },
  signatureApiKey: '',
};
